const getMuiSelect = () => ({
  styleOverrides: {
    root: {
      '& svg': {
        height: '20px',
        width: '20px',
      },
      fontSize: '12px',
    },
    outlined: {
      backgroundColor: 'var(--palette-semantic-surface-default)',
      position: 'relative' as const,
      paddingRight: 44,
      fontSize: '12px',
      '&.Mui-focused': {
        backgroundColor: 'inherit',
      },
    },
    icon: {
      height: '20px',
      width: '20px',
      top: 'calc(50% - 10px)',
      right: 0,
      padding: '0px 12px',
    },
    iconOpen: {
      transform: 'rotate(180deg)',
    },
    iconOutlined: {
      right: 0,
    },
    select: {
      height: 20,
      minHeight: 20,
      fontSize: '12px',
      '&&': {
        paddingRight: 44,
      },
    },
  },
  defaultProps: {
    MenuProps: {
      elevation: 1,
    },
  },
});
export default getMuiSelect;
